import { Component } from '@angular/core';

@Component({
  selector: 'fgbcl-contact-management-widget',
  templateUrl: './contact-management-widget.component.html',
  styleUrl: './contact-management-widget.component.scss'
})
export class ContactManagementWidgetComponent {

}
